<div class="nsw-container">
	<section class="component component--video-and-image-teaser nsw-card nsw-card--media nsw-wysiwyg-content flex-direction--row-reverse paragraph paragraph--type--video-image-teaser paragraph--view-mode--default">  
		<div class="card-content">
			<header class="nsw-card__content">  
				<h2 class="nsw-card__title">Want to receive regular updates for your swim site?</h2>			
				<div class="nsw-card__copy">
					<p>Sign up to daily emails for your favourite swimming spot or region and we'll help you decide when it's safe to swim.</p>
				</div>
				<div class="cta">
					<button type="button" routerLink="/userSubscriptions" class="nsw-button nsw-button--dark">Subscribe to Beachwatch</button>
				</div>				
			</header>
			<div class="nsw-card__image-area">
				<img src="assets/images/home/Bondi-Beach_compressed.webp" alt="subscribe" class="nsw-card__image">
			</div>	  
		</div>
	</section>  
</div>

